const GET_STEP_MULTIMEDIA = 'publicador-profesionales/multimedia/GET_STEP_MULTIMEDIA';
const SAVE_STEP_MULTIMEDIA = 'publicador-profesionales/multimedia/SAVE_STEP_MULTIMEDIA';
const ADD_MULTIMEDIA = 'publicador-profesionales/multimedia/ADD_MULTIMEDIA';
const MOVE_MULTIMEDIA = 'publicador-profesionales/multimedia/MOVE_MULTIMEDIA';
const DELETE_MULTIMEDIA = 'publicador-profesionales/multimedia/DELETE_MULTIMEDIA';
const UPDATE_MULTIMEDIA = 'publicador-profesionales/multimedia/UPDATE_MULTIMEDIA';
const PROCESSING_MULTIMEDIA = 'publicador-profesionales/multimedia/PROCESSING_MULTIMEDIA';
const BULK_ACTION_MULTIMEDIA = 'publicador-profesionales/multimedia/BULK_ACTION_MULTIMEDIA';
const ADD_ERROR_MULTIMEDIA = 'publicador-profesionales/multimedia/ADD_ERROR_MULTIMEDIA';
const CLEAN_MULTIMEDIA = 'publicador-profesionales/multimedia/CLEAN_MULTIMEDIA';
const VALIDATE_VIDEO_360 = 'publicador-profesionales/multimedia/VALIDATE_VIDEO_360';
const PREVIEW_STORAGE_IMAGE = 'publicador-profesionales/multimedia/PREVIEW_STORAGE_IMAGE';
const RESET_PREVIEW_STORAGE = 'publicador-profesionales/multimedia/RESET_PREVIEW_STORAGE';
const RESET_INFO = 'publicador-profesionales/multimedia/RESET_INFO';
const CLEAN_MULTIMEDIA_GET = 'publicador-profesionales/multimedia/CLEAN_MULTIMEDIA_GET';

export {
  GET_STEP_MULTIMEDIA,
  SAVE_STEP_MULTIMEDIA,
  ADD_MULTIMEDIA,
  MOVE_MULTIMEDIA,
  DELETE_MULTIMEDIA,
  UPDATE_MULTIMEDIA,
  BULK_ACTION_MULTIMEDIA,
  PROCESSING_MULTIMEDIA,
  ADD_ERROR_MULTIMEDIA,
  CLEAN_MULTIMEDIA,
  VALIDATE_VIDEO_360,
  PREVIEW_STORAGE_IMAGE,
  RESET_PREVIEW_STORAGE,
  RESET_INFO,
  CLEAN_MULTIMEDIA_GET
};
